import React, { FC, useState, useRef, useEffect } from "react";
// libs
import NextImage from "next/image";
// theme
import {
  DateContainer,
  CalendarContainer,
  TimeText,
  ArrowDown,
  DropdownContentTime,
  DropdownContainerFirst,
  DropdownItem,
  DropdownContainerSecond,
} from "./ChooseTime.styled";

interface IChooseTimeProps {
  initTime?: string;
  onChangeCb?: (time: string) => void;
}

const ChooseTime: FC<IChooseTimeProps> = ({ initTime = "Morning", onChangeCb }) => {
  const dropdownOpenTime: any = useRef();
  const [time, setTime] = useState<string>(initTime);
  const [openTime, setOpenTime] = useState<boolean>(false);

  const handleOpenTime = () => setOpenTime(!openTime);
  const handleTime = (times: string) => () => {
    onChangeCb?.(times);
    setTime(times);
  };

  const closeDropdownTime = (e: MouseEvent) => {
    setOpenTime(false);
    if (e) {
      e.stopPropagation();
    }
  };

  const handleClickTimeOutside = (event: MouseEvent): void => {
    if (!dropdownOpenTime.current.contains(event.target)) {
      closeDropdownTime(event);
    }
  };

  useEffect(() => {
    if (openTime) {
      document.addEventListener("mousedown", handleClickTimeOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickTimeOutside);
    };
  }, [openTime]);

  return (
    <DateContainer onClick={handleOpenTime} ref={dropdownOpenTime}>
      <CalendarContainer>
        <NextImage
          width={40}
          height={40}
          src={time === "Morning" ? "/icons/time.svg" : "/icons/Afternoon.svg"}
        />
      </CalendarContainer>
      <TimeText>{time}</TimeText>
      <ArrowDown>
        <NextImage width={12} height={7} src="/images/Home/arrow-down-grey.svg" />
      </ArrowDown>

      {openTime && (
        <DropdownContentTime>
          <DropdownContainerFirst onClick={handleTime("Morning")}>
            <CalendarContainer>
              <NextImage width={40} height={40} src="/icons/time.svg" />
            </CalendarContainer>
            <DropdownItem>Morning</DropdownItem>
          </DropdownContainerFirst>
          <DropdownContainerSecond onClick={handleTime("Afternoon")}>
            <CalendarContainer>
              <NextImage width={40} height={40} src="/icons/Afternoon.svg" />
            </CalendarContainer>
            <DropdownItem>Afternoon</DropdownItem>
          </DropdownContainerSecond>
        </DropdownContentTime>
      )}
    </DateContainer>
  );
};

export default ChooseTime;
